import ACS from "entity/Indicador/ACS";
import AS from "entity/Indicador/AS";
import IBF from "entity/Indicador/IBF";
import Perdas from "entity/Indicador/Perdas";
import Piso from "entity/Indicador/Piso";
import TMT from "entity/Indicador/TMT";
import TMM from "entity/Indicador/TMM";
import TTC from "entity/Indicador/TTC";
import Bio from "entity/Indicador/Bio"
import TipoIndicador from "..";
import ABA from "entity/Indicador/ABA";
import IMV from "entity/Indicador/IMV";
import PerdM from "entity/Indicador/PerdM";
import TC from "entity/Indicador/TC";

export default class Colheita extends TipoIndicador {
    static get fullName() {
        return "Colheita";
    }

    static get abbrev() {
        return "Colheita";
    }

    static get field() {
        return "colheitas";
    }

    static get indicadores() {
        return [Perdas, PerdM, Piso, AS, ABA, IBF, ACS, TTC, TMT, TMM, Bio, IMV, TC]
    }
}
